var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"450px"}},[_c('GmapMap',{staticClass:"ts-w-full ts-h-full",attrs:{"center":_vm.center,"zoom":_vm.zoom}},[_c('GmapMarker',{attrs:{"position":_vm.marker}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }